import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    familyList(data) {
        return axios.request({
            url: "mwap/votelist",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }
                    item.imgurl = `${item.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_292,h_217,ar_auto`
                    item.show_time = year+ month + date + " " + hour + ":" + minute;
                })
            }
            return res;
        });
    },
    submitVoteInfo(data) {
        return axios.request({
            url: "mwap/submitvoteinfo",
            method: "post",
            data
        });
    },
    submitVote(data) {
        return axios.request({
            url: "mwap/submitvote",
            method: "post",
            data
        });
    },
    voteRank(data) {
        return axios.request({
            url: "mwap/voterank",
            method: "post",
            data
        });
    }
}